<template>
	<div>
		<div id="upload">
			<h1>Upload Employee Keys</h1>
			<img v-if="employerLogo" style="margin-top: 20px; width: 70%; max-width: 300px; margin-bottom: 20px" :src="employerLogo" />
			
			<!-- <div class="alert alert-danger"><strong>We're experiencing high sign-up volumes</strong> - 
				Thank you for your interest in joining Money Guided! Due to an exceptionally high number of sign-ups, we're experiencing temporary delays. We're working hard to get everything running smoothly again, and we appreciate your patience.</div>

			<div style="clear:both; height: 700px"></div> -->
			
			
			<p>Please upload your employee keys to the system.  This will allow your employees to access the system and use the app.</p>

			<div class="form-group">
				<textarea 
					v-model="employeeKeys" 
					class="form-control" 
					rows="10" 
					placeholder="Enter a list of employee keys, one per line"
					style="font-family: monospace; margin: 20px 0;"
				></textarea>
			</div>

			<div class="alert alert-danger" v-if="errorMessage">{{ errorMessage }}</div>
			<div class="alert alert-success" v-if="successMessage">{{ successMessage }}</div>

			<button
				class="btn btn-primary"
				@click="uploadKeys"
				:disabled="!employeeKeys || employeeKeys.length === 0"
				>Upload Keys
			</button>

			<div class="help-text">
				<h3>Format Instructions</h3>
				<p>Please enter your employee keys in the following format:</p>	
				<pre>
employeeKey1
employeeKey2
employeeKey3
etc
				</pre>
			</div>
		</div>


	</div>
	
</template>

<script>

export default {
	components: {  },
	name: "UploadEmployeeKeys",
	data: function() {
		return {
			message: '',
			employerId: null,
			code: null,
			employerLogo: null,
			employeeKeys: [],
			errorMessage: '',
			successMessage: ''
		}
	},
	methods:
	{
		uploadKeys: function() {
			try {
				const keysDataList = this.employeeKeys.split('\n');
				
				// Validate the structure
				if (!keysDataList || !Array.isArray(keysDataList)) {
					this.errorMessage = 'Invalid format: missing employees keys';
					return;
				}

				// hash the keys
				// md5 hash the keys
				const hashedKeys = keysDataList.map(key => {
					const crypto = require('crypto');
					return crypto.createHash('md5').update(key).digest('hex');
				});

				this.$http.post(this.$route.meta.api + '/Employers/' + this.employerId + '/CreateEmployerGatewayKeysRequestsEx', {
					authCode: this.code,
					employerId: this.employerId,
					keys: hashedKeys
				}).then(response => {
					console.log(response);
					this.successMessage = 'Employee keys uploaded successfully!';
					this.errorMessage = '';
					this.employeeKeys = '';
				}).catch(error => {
					this.errorMessage = error.response?.data?.message || 'Failed to upload employee keys. Please try again.';
					this.successMessage = '';
				});
			} catch (error) {
				console.log(error);
				this.errorMessage = 'Invalid format';
			}
		},
		getEmployerLogo: function() {
			this.$http.get(this.$route.meta.api + '/Employers/' + this.employerId + '/logo').then(response => {
				this.employerLogo = response.data;
			});
		}
	},
	mounted: function() {
		if (!this.$route.query.c) {
			this.$router.push({ path: '/home' });
		}
		this.employerId = this.$route.query.e;
		this.code = this.$route.query.c;
		this.getEmployerLogo();
	},
}
</script>

<style scoped>

	#upload {
		padding-top: 130px;
		padding-bottom: 130px;
		width: 60%;
		min-width: 300px;
		margin-left: auto;
		margin-right: auto;
	}

	.dl
	{
		background-color: #281c3bea;
		border-radius: 3%;
		padding: 50px;
		padding-top: 30px;
		margin: 10px;
		max-width: 400px;
		color: #ffffff;
	}

	.dl img{
		margin-top: 30px;
		width: 100%;
		max-height: 80px;
	}

	.centered {
		text-align: center !important;
	}

	h1 {
		font-size: 27px;
		font-weight: bold;
		margin-bottom: 10px;
		text-align: left;
	}
	h1 {
		text-align: center;
	}
	h2 {
		font-size: 18px;
		font-weight: bold;
		margin-bottom: 5px;
		margin-top: 30px;
	}
	.row {
		text-align: left;
	}

	p {
		text-align: left;
	}

	@media all and (max-width: 767px)
	{
		#upload,p,h1 {
			text-align: center;
		}
	}

	.help-text {
		margin-top: 20px;
		text-align: left;
		background: #f8f9fa;
		padding: 20px;
		border-radius: 4px;
	}

	.help-text pre {
		background: #2d2d2d;
		color: #fff;
		padding: 15px;
		border-radius: 4px;
		overflow-x: auto;
	}

	.alert {
		margin: 20px 0;
		padding: 15px;
		border-radius: 4px;
	}

	.alert-danger {
		background-color: #f8d7da;
		border: 1px solid #f5c6cb;
		color: #721c24;
	}

	.alert-success {
		background-color: #d4edda;
		border: 1px solid #c3e6cb;
		color: #155724;
	}

	.btn {
		margin-top: 20px;
	}

	textarea {
		width: 100%;
		min-height: 200px;
		font-family: monospace;
		white-space: pre;
		tab-size: 2;
	}

</style>

<style>
	.feature-carousel {
		padding-bottom: 60px;
		background-color: #ffffff !important;
	}

	.btn {
		width: 100% !important;
		max-width: 400px !important;
		font-size: 14px !important;
		height: unset !important;
	}
</style>